import { HttpClient } from '@angular/common/http';
import { Base } from '../base';

export class TradeSignatures extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/trade_signatures`);
  }

  get(id: any) {
    return this.api.get(id);
  }

  create(record: any) {
    return this.api.create(record);
  }

  getGas(record: any) {
    return this.api.httpClient.post(`${this.path}/gas`, record);
  }

  getNonce(account: string) {
    return this.api.get('nonce', { account });
  }
}
